import { useEffect, useState } from 'react';

// Live-updating reduced motion hook with safe fallback.
export function useReducedMotion() {
    const [reduced, setReduced] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined' || !('matchMedia' in window)) return;
        let mql: MediaQueryList | null = null;
        try {
            mql = window.matchMedia('(prefers-reduced-motion: reduce)');
            setReduced(mql.matches);
            const handler = (e: MediaQueryListEvent) => setReduced(e.matches);
            if (mql.addEventListener) {
                mql.addEventListener('change', handler);
                return () => mql && mql.removeEventListener('change', handler);
            } else if ((mql as any).addListener) { // Safari fallback
                (mql as any).addListener(handler);
                return () => (mql as any).removeListener(handler);
            }
        } catch {
            // ignore
        }
    }, []);

    return reduced;
}
